import React from 'react'
import './style.css'

function Index({ address, id, ghLink }) {
  return (
    <div className='frameContainer' >
      <iframe id={id} title='frame' className='frame' src={address} />

      <div className='linkGroup' >
        <a href={address} target="_blank">[ Visit Live ] </a>
        <a href={ghLink} target="_blank">[ Source Code ] </a>
      </div>
    </div>
  )
}

export default Index
